// The `<data_sources>` account-scope directive, split out of explore-context-preamble.util at the 300-line cap.
import { AgentMessageTag, wrapAgentMessageSection } from '@logz-pkg/models';

// Account-scope directive (ORIONIQ-1138) — advisory; provisional wording that names the backend
// `account_scope_confirmed` flag. Two variants keep the wording matched to what <page_context> lists (the
// user's selected accounts, or none), so it never claims accounts that aren't there. See app-ui/CLAUDE.md.
const SELECTED_ACCOUNTS_DIRECTIVE = [
  'The account(s) listed in the page context above are the datasources the user already selected for this ' +
    "investigation. Treat them as the user's explicit, confirmed account scope: query them directly and do NOT " +
    'ask the user to pick or re-confirm which account(s) to use.',
  'When invoking the telemetry agent, pass them as an already-confirmed scope (account_scope_confirmed=true) so ' +
    'no scope-clarification turn is needed.',
  'Only pause to ask the user to narrow the scope when so many accounts are selected that querying them all ' +
    'would be impractical or risk an oversized result.',
].join('\n');

const CURRENT_ACCOUNT_DIRECTIVE =
  'The page context above lists no specific account. Query the account this session is scoped to — the account ' +
  "that initiated this request (the user's current account) — as the confirmed scope (account_scope_confirmed=true), " +
  'and do NOT ask the user which account to use.';

export const SELECTED_ACCOUNTS_BLOCK = wrapAgentMessageSection(AgentMessageTag.dataSources, SELECTED_ACCOUNTS_DIRECTIVE);
export const CURRENT_ACCOUNT_BLOCK = wrapAgentMessageSection(AgentMessageTag.dataSources, CURRENT_ACCOUNT_DIRECTIVE);
